"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageName = void 0;

var getPageName = function getPageName(path, isOnboardingCompleted) {
  switch (path) {
    case "transactions":
      return "Transactions";

    case "settlements":
      return "Settlements";

    case "payment-gateway":
      return "Payment gateway page";

    case "buttons":
      return "Payment buttons page";

    case "payment-links":
      return "Payment link page";

    case "reports":
      return "Reports page";

    case "reports/create":
      return "Generate report";

    case "invoices":
      return "Invoices page";

    case "dmt":
      return "DMT page";

    case "payouts":
      return "Payouts page";

    case "settings":
      return "Settings";

    case "banking":
      return "Banking Page";

    case "marketplace":
      return "Marketplace Page";

    case "lending":
      return "Lending Page";

    case "batch-refunds":
      return "Batch Refunds";

    case "business":
    case "":
      if (isOnboardingCompleted) {
        return "Summary page";
      } else {
        return "Zero state screen";
      }

    default:
      return path;
  }
};

exports.getPageName = getPageName;